import { computed, type Ref } from 'vue'
import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'
import { unwrapFullTypesList } from '@/entities/Inventory/MapTypes/model/unwrapFullTypesResponse'

/**
 * Загрузка всех типов конкретного объекта
 * @param objectId
 */
export const useLoadInventTypesByObject = (objectId: Ref<number>) => {
  const http = useHttp()

  const url = computed(() => {
    return `/inventory/objects/${objectId.value}/inventory-types/elements-count`
  })

  const queryKey = computed(() => ['load_invent_types_by_object', objectId])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

/**
 * Загрузка полного дерева типов объекта (родители + подтипы).
 * Применяется для разрешения id подтипа → родительский тип.
 * Запрос выполняется только когда `enabled` === true.
 * @param objectId
 * @param enabled
 */
export const useLoadInventoryObjectTypesFull = (
  objectId: Ref<number>,
  enabled: Ref<boolean>,
) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_inventory_object_types_full', objectId])

  const url = computed(() => `/inventory/objects/${objectId.value}/object-types/full`)

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    enabled,
    retry: false,
    select: (resp: unknown) => unwrapFullTypesList(resp),
  })
}
